import getCombatantIndexById from "./getCombatantIndexById";
import store from "../store/index";
//-----------------------
// reduce reaction count
//-----------------------
export default function reduceReactionCount(id) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //--------------------
  // get combatant index
  //--------------------
  let idx = getCombatantIndexById(id);
  //-----------------------
  // reduce reaction count
  //-----------------------
  combatants[idx].reaction_count--;
}
